import React, { useCallback, useEffect } from 'react';
import { RadioButton } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  metaDataSelector,
  metaKeySelector,
  setMetaData,
} from 'features/superBatchManagement';
import Field from 'components/Field';
import styles from './SuperBatchUpdateMetaPage.module.scss';

function CoursePauseInputs() {
  const dispatch = useDispatch();
  const metaKey = useSelector(metaKeySelector);
  const metaData = useSelector(metaDataSelector);

  const handleCoursePauseStateChange = useCallback(
    (event) => {
      dispatch(setMetaData(event.target.name === 'true'));
    },
    [dispatch]
  );

  useEffect(() => () => dispatch(setMetaData({})), [dispatch]);

  return (
    <>
      <Field
        label={`Enable/Disable ${metaKey.label}.`}
        className={styles.select}
      >
        <RadioButton
          active={metaData === true}
          name="true"
          text="Enable"
          onChange={handleCoursePauseStateChange}
        />
        <RadioButton
          active={metaData === false}
          name="false"
          text="Disable"
          onChange={handleCoursePauseStateChange}
        />
      </Field>
    </>
  );
}

export default CoursePauseInputs;
